function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.05 1H15.75V4.575L19.6364 5.63492C20.7892 5.94932 21.4109 7.19779 20.9671 8.30723L17.835 16.1374C17.5553 16.8368 17.5489 17.6157 17.817 18.3196L19.6 23H4.2L5.98301 18.3196C6.25115 17.6157 6.24471 16.8368 5.96498 16.1374L2.83289 8.30723C2.38912 7.1978 3.01081 5.94932 4.16361 5.63492L8.05 4.575V1Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 6.16846,
  y1: 16.9236,
  x2: 18.1527,
  y2: 16.9236,
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 11.825,
  y1: 1,
  x2: 11.825,
  y2: 16.4,
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var SvgSampling = function SvgSampling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSampling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sampling.9179a8ba.svg";
export { ForwardRef as ReactComponent };